import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { isTrackingActiveAtom } from '../../atoms/ml-tracking-atoms';
type Props = {
  onTrackingActiveChange: (isActive: boolean) => void;
};

/**
 * Bridges `isTrackingActiveAtom` out of the studio's isolated jotai store (created by
 * `StudioAtomHydrator`'s `<Provider>`) to consumers rendered above that store — e.g. the
 * ulabel-lite submit button and the auto-pause hook. Those consumers cannot read the atom
 * directly, so this null-rendering observer (mounted inside the provider, mirroring
 * `OutputObserver`) pushes the value out through a callback.
 */
export const TrackingActiveObserver = ({
  onTrackingActiveChange
}: Props) => {
  const isTrackingActive = useAtomValue(isTrackingActiveAtom);
  useEffect(() => {
    onTrackingActiveChange(isTrackingActive);
  }, [isTrackingActive, onTrackingActiveChange]);
  return null;
};